import { render, staticRenderFns } from "./SettingLeads.vue?vue&type=template&id=1249423a&scoped=true"
import script from "./SettingLeads.vue?vue&type=script&lang=js"
export * from "./SettingLeads.vue?vue&type=script&lang=js"
import style0 from "./SettingLeads.vue?vue&type=style&index=0&id=1249423a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1249423a",
  null
  
)

export default component.exports